import { Auth } from "aws-amplify";
import { logOutUser } from "lib/session/logOut";

export const getTokenExpirationTimeFromUser = user => {
  const expirationIdtokenTimeSeconds =
    user.signInUserSession.idToken.payload.exp;
  const expirationIdtokenTimeMiliseconds = expirationIdtokenTimeSeconds * 1000;
  return expirationIdtokenTimeMiliseconds;
};

export const checkTokenExpirationTime = () => {
  Auth.currentAuthenticatedUser().then(user => {
    const currentTime = Date.now();
    const tokenExpirationTime = getTokenExpirationTimeFromUser(user);
    if (currentTime > tokenExpirationTime) {
      logOutUser();
    }
  });
};

export default checkTokenExpirationTime;
